module.exports = __webpack_public_path__ + "img/racquet.30a45cf0.svg";